import { Controller } from "@hotwired/stimulus"
import consumer from "channels/consumer"

// Handles real-time attachment processing status updates via ActionCable
// Replaces: app/assets/javascripts/channels/attachment_process_channel.js
export default class extends Controller {
  static targets = ["container", "status"]
  static values = {
    attachmentId: Number,
    doneText: String,
    failedText: String
  }

  connect() {
    if (this.hasAttachmentIdValue) {
      // Find and remove any existing AttachmentProcessChannel subscription for this attachment
      // (don't remove AttachmentValidationChannel or other channel subscriptions!)
      const existingSubscription = consumer.subscriptions.subscriptions.find(sub => {
        try {
          const identifier = JSON.parse(sub.identifier)
          return identifier.channel === 'AttachmentProcessChannel' &&
                 identifier.attachment_id === this.attachmentIdValue
        } catch (e) {
          return false
        }
      })
      if (existingSubscription) {
        consumer.subscriptions.remove(existingSubscription)
      }

      this.subscription = consumer.subscriptions.create(
        {
          channel: "AttachmentProcessChannel",
          attachment_id: this.attachmentIdValue
        },
        {
          connected: this.connected.bind(this),
          disconnected: this.disconnected.bind(this),
          received: this.received.bind(this)
        }
      )
    }
  }

  disconnect() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription)
      this.subscription = null
    }
  }

  connected() {
    // ActionCable connection established
  }

  disconnected() {
    // ActionCable connection closed
  }

  received(data) {
    // Update container HTML based on status
    if (data.status === 'done' && this.hasDoneTextValue && this.hasContainerTarget) {
      this.containerTarget.innerHTML = this.doneTextValue
    } else if (data.status === 'failed' && this.hasFailedTextValue && this.hasContainerTarget) {
      this.containerTarget.innerHTML = this.failedTextValue
    }

    // Update status message
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = data.message
    }
  }
}
